module.exports = __webpack_public_path__ + "img/greennote.cc637bfa.png";